import { useEffect, useMemo, useState } from "react";
import { useAccount } from "wagmi";

export const useProvider = () => {
 const [provider, setProvider] = useState<{
  isWalletConnect: boolean;
  request: (opts: unknown) => Promise<unknown>;
 }>();
 const { connector } = useAccount();
 useEffect(() => {
  if (connector) {
   connector.getProvider().then(setProvider);
  } else {
   setProvider(undefined);
  }
 }, [connector]);
 const isWalletConnect = useMemo(() => {
  return Boolean(provider?.isWalletConnect);
 }, [provider]);
 return { provider, isWalletConnect };
};
